export default function($) {
  const speed = 90;

  $('.menu-item-has-children a').attr({ 'aria-haspopup': 'true', 'aria-expanded': 'false' });

  $('.menu-item-has-children').on('click', function(e) {
    e.stopPropagation();
    const $item = $(this);
    const isActive = $item.hasClass('menu-item-has-children--active');

    $item.siblings('.menu-item-has-children--active')
      .removeClass('menu-item-has-children--active')
      .children('.sub-menu').slideUp(speed)
      .end().find('a').attr('aria-expanded', 'false');

    $item.children('.sub-menu').slideToggle(speed);
    $item.toggleClass('menu-item-has-children--active');
    $item.find('a').attr('aria-expanded', isActive ? 'false' : 'true');
  });

  $(document).on('click', function(e) {
    if (!$(e.target).closest('.js-nav').length && $('.sub-menu:visible').length) {
      $('.sub-menu').slideUp(speed);
      $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      $('.menu-item-has-children a').attr('aria-expanded', 'false');
    }
  });

  $(window).on('scroll', function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
